/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_SavingInputs */

const en_us2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const pt_br2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando…`)
};

const es_419_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando…`)
};

const pt_pt2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guardar…`)
};

const fr_fr2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement…`)
};

const de_de2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gespeichert…`)
};

const it_it2_coach_manage_rename_saving = /** @type {(inputs: Coach_Manage_Rename_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Coach_Manage_Rename_SavingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_saving = /** @type {((inputs?: Coach_Manage_Rename_SavingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_SavingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_saving(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_saving(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_saving(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_saving(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_saving(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_saving(inputs)
	return en_us2_coach_manage_rename_saving(inputs)
});
export { coach_manage_rename_saving as "coach-manage.rename_saving" }